import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { AddCryoboxToStagingInput, AddCryoboxToStagingResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const addCryoboxToStagingThunk = createAsyncThunk(
  'shipment/addCryoboxToStaging',
  async (values: AddCryoboxToStagingInput, { rejectWithValue }: any) => {
    const response: AddCryoboxToStagingResponse = await labApi.addCryoboxToStaging(values);
    if (response.data?.addCryoboxToStaging) {
      return response.data?.addCryoboxToStaging;
    }
    return rejectWithValue(response.errors);
  },
);
